
'use strict';

const $ = require('jquery');
import 'truncate.js';
import {parallelArrayEach} from '../../utilities/uiLoopHelpers';

export default class EllipsisView {

  constructor($ellipses, options = {}) {
    this.$ellipses = $ellipses;
    parallelArrayEach(this.$ellipses, (el) => {
      this.initializeDefer(el, options);
    });
  }

  initializeDefer(el, options) {
    const $el = $(el);
    $el.truncate({
      lines: options.lines || $el.data('ellipsisLines') || 2
    });
  }

}

export function create($parent) {
  var $ellipses = $parent.find('.js-ellipsis');
  if ($ellipses.length) {
    new EllipsisView($ellipses);
  }
}




// WEBPACK FOOTER //
// ./assets/components/Ellipsis/EllipsisView.js